
<div class="forgot-password">
  <div>
    <img
      height="36"
      alt="Card Ladder"
      src="@cardladder/shared/images/cardladder-pro-logo.svg"
    />
  </div>

  <div class="form-container">
    <h2>Reset Password</h2>

    <form @submit.prevent="submit">
      <p>Enter your email address below to receive an email to reset your password.</p>
      <p>If you login with Apple or Google this will NOT send you an email.</p>

      <text-input
        id="email"
        v-model.trim="email"
        type="email"
        label="Email"
        required
      />

      <btn
        loading-text="Submitting"
        type="submit"
        block
        :loading="submitting"
      >
        Submit
      </btn>

      <div class="links">
        <a class="link" @click="$router.push({ path: '/login', query: $route.query })">Back to login</a>
      </div>
    </form>
  </div>
</div>
